require('./squaresRow.scss');

const PropTypes = require('prop-types');

const React = require('react');
const classNames = require('classnames');
const Square = require('./square');

class SquaresRow extends React.Component {

    buildRow(maximum, level) {
        const squares = [];
        for (let i = 1; i <= maximum; i++) {
            squares.push(<Square active={i <= level}/>);
        }
        return squares;
    }

    render() {
        const { maximum, level, customClassName } = this.props;
        const className = classNames('squares-row', customClassName);
        const squares = this.buildRow(maximum, level).map( (square, index) => {
            return (
                <li className="squares-row__squares-list-item" key={index}>
                    {square}
                </li>
            );
        });
        return (
            <div className={className}>
                <ul className="squares-row__squares-list">
                    {squares}
                </ul>
            </div>
        );
    }
}

SquaresRow.propTypes = {
    maximum: PropTypes.number.isRequired,
    level: PropTypes.number.isRequired,
    customClassName: PropTypes.string
}

module.exports = SquaresRow;